angular.module('lf.desktop')

.controller('StarterSuccessCtrl', function ($scope, helpers) {

	$scope.tabSwitchLFCToFullScreen = function () {
		helpers.utils.lfc.lfcFullScreenAppCenter(1, "complete");
	}

	$scope.packageSkus = lf.data.starterSuccessData.packageSkus;
});
